import { useEffect, useState } from "react"
import { buildLandingMotion, type LandingMotionState, type ScrollDirection } from "./landing-motion"

function readProgress() {
  if (typeof window === "undefined") return 0
  const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight)
  return Math.max(0, Math.min(1, window.scrollY / max))
}

export function useScrollProgress(): LandingMotionState {
  const [motion, setMotion] = useState(() => buildLandingMotion(0))

  useEffect(() => {
    let raf = 0
    let lastProgress = readProgress()
    let lastTime = performance.now()

    const update = () => {
      cancelAnimationFrame(raf)
      raf = requestAnimationFrame(() => {
        const nextProgress = readProgress()
        const now = performance.now()
        const dt = Math.max(16, now - lastTime)
        const delta = nextProgress - lastProgress
        const velocity = delta / dt
        const direction: ScrollDirection = Math.abs(delta) < 0.0004 ? 0 : delta > 0 ? 1 : -1
        lastProgress = nextProgress
        lastTime = now
        setMotion(buildLandingMotion(nextProgress, velocity, direction))
      })
    }

    update()
    window.addEventListener("scroll", update, { passive: true })
    window.addEventListener("resize", update, { passive: true })
    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener("scroll", update)
      window.removeEventListener("resize", update)
    }
  }, [])

  return motion
}
